import { createSlice } from "@reduxjs/toolkit";
import { AppCache } from "../../helpers/myStorage";

const initialState = {
  languages: [
    { code: "fr", name: "FR" },
    { code: "en", name: "EN" },
    { code: "tr", name: "TR" },
    { code: "de", name: "DE" },
  ],
  language: AppCache.getCurrentLanguage(),
};
const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    switchLanguage(state, action) {
      state.language = action.payload;
      AppCache.setCurrentLanguage(action.payload);
    },
  },
});

export const { switchLanguage } = languageSlice.actions;

export default languageSlice.reducer;
